import {useEffect} from 'react';
import {Category, CategoryError} from '@/components/main/directory/category';
import {useParams, useNavigate} from 'react-router-dom';
import useDirectoryStore from '@/stores/directory';
import AdminCategory from '@/components/main/directory/admin/AdminCategory';

/**
 * URL과 categoryMenu 정보를 통해 카테고리/어드민 칩 분기를 담당하는 컴포넌트
 * @returns
 */
const DiscoverCategoryDetail = () => {
  const {
    categoryMenu,
    selectedCategoryInfo,
    clearSelectedCategoryInfo,
    setSelectedCategoryInfo,
    setSelectedCategoryTab,
  } = useDirectoryStore();

  const {categoryName, categoryType} = useParams();
  const navigate = useNavigate();
  /** URL 유효성 체크 */
  const isValid =
    categoryName &&
    categoryType &&
    ['live', 'vod', 'catch'].includes(categoryType);

  /** URL을 통해 선택된 카테고리칩을 설정한다. */
  useEffect(() => {
    /** URL에 제공된 categoryName이 어드민 칩을 의미하는지 찾는다 */
    const foundCategoryInfo = categoryMenu.find(
      (menu) => menu.menuId !== 0 && Number(categoryName) === menu.menuId,
    );
    if (!foundCategoryInfo) {
      clearSelectedCategoryInfo();
    } else {
      setSelectedCategoryInfo({
        type: foundCategoryInfo.type,
        adminId: foundCategoryInfo.adminId,
        menuName: foundCategoryInfo.menuName,
        menuId: foundCategoryInfo.menuId,
        contentsDisplay: {
          live: foundCategoryInfo.contentsDisplay?.live,
          vod: foundCategoryInfo.contentsDisplay?.vod,
          catch: foundCategoryInfo.contentsDisplay?.catch,
        },
      });
    }
  }, [
    categoryMenu,
    categoryName,
    clearSelectedCategoryInfo,
    setSelectedCategoryInfo,
  ]);

  /** URL의 categoryType 변화에 반응한다. */
  useEffect(() => {
    if (isValid) {
      setSelectedCategoryTab(categoryType);
    }
  }, [isValid, categoryType, setSelectedCategoryTab]);

  /** 잘못된 URL로 들어왔다면 카테고리 페이지로 이동 */
  useEffect(() => {
    if (!isValid) {
      navigate(`/directory/category`);
    }
  }, [isValid, navigate]);

  if (isValid) {
    return selectedCategoryInfo.menuId === 0 ? (
      <Category categoryName={categoryName} categoryType={categoryType} />
    ) : (
      <AdminCategory categoryName={categoryName} categoryType={categoryType} />
    );
  } else {
    return <CategoryError />;
  }
};

export default DiscoverCategoryDetail;
